webpackJsonp([185121392984766],{

/***/ 1865:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"MedicationsReportResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"medications","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"MedicationsReportItem","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"totalCount","type":{"kind":"SCALAR","name":"Int","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-medications-report-result-23a799ca38eca8ebef29.js